import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import store from './store'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import Buffer from 'buffer';
Vue.config.productionTip = false
Vue.use(ElementUI);
window.Buffer = Buffer.Buffer; // 全局暴露Buffer
new Vue({
  router,
  store,  // 注入store到所有组件
  render: h => h(App),
}).$mount('#app')
